import { useState } from "react";
import { GraduationCap, BookOpen, Clock, CalendarDays, ChevronRight } from "lucide-react";
import { PeriodsDialog } from "@/components/PeriodsDialog";
import { SubjectsDialog } from "./SubjectsDialog";
import { PromotionDialog } from "./PromotionDialog";
import { TeacherSchedulesDialog } from "./TeacherSchedulesDialog";

const TILES = [
  { key: "periods", Icon: Clock, title: "Periods", desc: "Bell schedule — name, start and end time of each period." },
  { key: "subjects", Icon: BookOpen, title: "Subjects", desc: "The catalog of subjects teachers can be scheduled for." },
  { key: "schedules", Icon: CalendarDays, title: "Teacher schedules", desc: "Weekly timetable per teacher; edit periods, rooms and rosters." },
  { key: "year", Icon: GraduationCap, title: "New school year", desc: "Promote every grade up one level and graduate the top grade." },
];

/** School-only setup tiles on the Settings page. */
export function SchoolSetup() {
  const [open, setOpen] = useState(null);
  return (
    <section className="rounded-xl border border-slate-200 bg-white p-6" data-testid="school-setup">
      <div className="flex items-center gap-2 mb-1"><GraduationCap className="h-4 w-4 text-primary" /><span className="text-xs font-medium uppercase tracking-widest text-slate-500">School setup</span></div>
      <p className="text-xs text-slate-500 mb-4">Academic configuration used by Grades, teacher profiles and the parent app.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3">
        {TILES.map(({ key, Icon, title, desc }) => (
          <button key={key} type="button" onClick={() => setOpen(key)} data-testid={`setup-${key}-btn`}
            className="group flex items-start gap-3 rounded-xl border border-slate-200 bg-slate-50/60 p-4 text-left hover:border-primary/40 hover:bg-primary/5 transition-colors">
            <div className="h-9 w-9 shrink-0 rounded-lg bg-white border border-slate-200 flex items-center justify-center text-primary group-hover:border-primary/40"><Icon className="h-[18px] w-[18px]" /></div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold text-slate-900 flex items-center gap-1">{title}<ChevronRight className="h-3.5 w-3.5 text-slate-300 group-hover:text-primary transition-colors" /></div>
              <div className="text-xs text-slate-500 mt-0.5">{desc}</div>
            </div>
          </button>
        ))}
      </div>
      {open === "periods" && <PeriodsDialog onClose={() => setOpen(null)} onChanged={() => {}} />}
      <SubjectsDialog open={open === "subjects"} onOpenChange={(o) => !o && setOpen(null)} />
      <PromotionDialog open={open === "year"} onOpenChange={(o) => !o && setOpen(null)} />
      <TeacherSchedulesDialog open={open === "schedules"} onOpenChange={(o) => !o && setOpen(null)} />
    </section>
  );
}
